import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinmaval() {



  const cardData =
  {
    keyword: 'Bus On Rent in Maval',
    heading: 'Sanavi Travels: Bus On Rent in Maval',
    headingDescription: 'Sanavi Travels offers reliable Bus On Rent in Maval, providing safe, comfortable, and spacious transportation for families, groups, corporate outings, school excursions, weddings, and tourist travel across the Maval region. Our fleet of well-maintained AC and non-AC buses, mini buses, and luxury coaches ensures ample seating, smooth rides, and sufficient luggage space for a hassle-free journey. With professional drivers, flexible one-way and round-trip rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Maval, Lonavala, Khandala, Talegaon, and nearby Pune areas, making it ideal for local sightseeing, outstation trips, corporate travel, and group tours. Choose Sanavi Travels for trusted bus rental services in Maval, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Maval with Sanavi Travels',


"topPlaces": [
  {
    "title": "Maval Region (Maval Taluka)",
    "description": "Maval is a scenic and historically rich region located in the Sahyadri mountain range near Pune, forming a natural gateway between Pune and Mumbai. Known for its lush valleys, rolling hills, and dense monsoon greenery, Maval played a crucial role during the Maratha era as a strategic corridor used by Chhatrapati Shivaji Maharaj. The region is blessed with pleasant weather throughout the year and becomes exceptionally beautiful during the monsoon season when waterfalls, streams, and mist-covered hills transform the landscape into a green paradise."
  },
  {
    "title": "Lohagad Fort",
    "description": "Lohagad Fort is one of the most famous hill forts in the Maval region and a significant stronghold of the Maratha Empire. Used by Chhatrapati Shivaji Maharaj to store treasures, the fort is known for its strong fortifications, wide plateaus, and the iconic Vinchu Kata (Scorpion’s Tail) structure. The trek to Lohagad is easy yet rewarding, making it popular among families, beginners, and history enthusiasts. During monsoon, the fort is surrounded by clouds and lush greenery, offering breathtaking views."
  },
  {
    "title": "Visapur Fort",
    "description": "Visapur Fort, located near Lohagad, is a massive hill fort built during the early Peshwa period. Taller and larger than Lohagad, it offers panoramic views of the entire Maval valley. The fort is known for its ruins, large stone structures, old water tanks, and historical caves. Trekking to Visapur during the rainy season is an adventurous experience due to waterfalls flowing along the route and the fort walls."
  },
  {
    "title": "Pavana Dam and Pavana Lake",
    "description": "Pavana Dam and its vast lake are among the most serene attractions in the Maval region. Surrounded by hills and open grasslands, the lake offers stunning sunset views and a peaceful atmosphere. It is a popular destination for camping, photography, and lakeside picnics. The calm waters combined with starry night skies make Pavana Lake a favorite weekend escape for travelers from Pune and Mumbai."
  },
  {
    "title": "Tikona Fort",
    "description": "Tikona Fort, also known as Vitandgad, stands out due to its distinctive triangular shape. Located near Pavana Lake, this fort offers a moderately challenging trek and rewards visitors with breathtaking views of surrounding forts, valleys, and water bodies. Historically, Tikona Fort was an important watchtower controlling trade routes in the Maval region. The fort’s gates, caves, and water tanks reflect Maratha military architecture."
  },
  {
    "title": "Rajmachi Fort",
    "description": "Rajmachi Fort is a historic twin-fort complex consisting of Shrivardhan and Manaranjan forts, nestled deep within the Maval hills. It played a key role in controlling the Bor Ghat trade route during the Maratha period. Rajmachi is famous for its long scenic trek, firefly sightings before monsoon, and lush greenery during rains. The fort offers a perfect blend of adventure, history, and natural beauty."
  },
  {
    "title": "Karla and Bhaja Caves",
    "description": "The ancient Karla and Bhaja Caves are rock-cut Buddhist monuments dating back over 2,000 years. Located in the Maval region, these caves feature grand chaitya halls, intricately carved pillars, and prayer spaces used by monks. The Karla Chaitya is one of the largest and best-preserved Buddhist prayer halls in India, showcasing exceptional ancient craftsmanship and spiritual heritage."
  },
  {
    "title": "Bedse Caves",
    "description": "Bedse Caves are lesser-known yet beautiful rock-cut Buddhist caves located amidst quiet hills of Maval. Reached via a short trek through villages and greenery, these caves offer peace, scenic views, and historical significance. Their calm surroundings make them ideal for travelers seeking solitude and offbeat heritage experiences."
  },
  {
    "title": "Tung Fort",
    "description": "Tung Fort, rising steeply from the Pavana Lake area, is a compact yet dramatic hill fort. The trek to Tung is short but steep, making it popular among adventure seekers. The fort provides spectacular panoramic views of Pavana Lake, Tikona, and Lohagad forts. Historically, Tung Fort served as a strategic lookout point during the Maratha era."
  },
  {
    "title": "Maval Villages and Rural Culture",
    "description": "The villages of Maval reflect authentic rural Maharashtrian life, with farming landscapes, traditional houses, and local cuisine. Visitors can experience warm hospitality, regional food, and simple living amidst nature. The region’s rural charm, combined with its historical and natural richness, makes Maval a perfect destination for cultural and eco-tourism."
  }
]
,



"services": [
{
"name": "Bus On Rent in Maval",
"description": "Bus On Rent in Maval offers dependable and comfortable bus rental services for a wide range of travel needs including local sightseeing, group outings, family trips, and long-distance journeys. The service focuses on safety, cleanliness, and punctuality, providing well-maintained buses with spacious seating and professional drivers who ensure smooth travel across Maval and nearby destinations. It is ideal for tourists, families, corporate groups, and event travelers seeking reliable group transportation."
},
{
"name": "Bus Hire Maval",
"description": "Bus Hire Maval provides flexible and convenient bus hiring solutions designed to meet different travel requirements. With multiple seating capacities, modern interiors, and transparent pricing, this service is suitable for picnics, weddings, corporate travel, religious tours, and weekend trips. Experienced drivers and reliable scheduling make Bus Hire Maval a trusted choice for safe and hassle-free group travel."
},
{
"name": "AC Bus Maval",
"description": "AC Bus Maval ensures a cool, relaxed, and comfortable travel experience with fully air-conditioned buses that are ideal for long journeys and group travel. These buses are designed to provide smooth rides, comfortable seating, and a pleasant environment, making them perfect for tourists, families, and corporate travelers exploring Maval and surrounding areas."
},
{
"name": "Luxury Bus Maval",
"description": "Luxury Bus Maval offers premium bus travel with high-end vehicles featuring pushback seats, ample legroom, and superior comfort. Ideal for VIP travel, corporate outings, destination weddings, and luxury tours, these buses enhance the overall travel experience by combining style, comfort, and professional service."
},
{
"name": "Tourist Bus Maval",
"description": "Tourist Bus Maval caters to travelers exploring Maval, nearby hill stations, forts, and popular tourist attractions. With flexible itineraries, spacious seating, and knowledgeable drivers, this service ensures a convenient, enjoyable, and well-organized sightseeing experience for groups and tourists."
},
{
"name": "Picnic Bus Maval",
"description": "Picnic Bus Maval is specially designed for school trips, family picnics, and group outings to scenic destinations around Maval. The service emphasizes safety, comfort, and timely travel, offering spacious buses and experienced drivers to make picnic journeys enjoyable and stress-free."
},
{
"name": "Corporate Bus Maval",
"description": "Corporate Bus Maval provides organized and professional transportation for corporate meetings, factory visits, team outings, conferences, and office travel. With disciplined drivers, punctual service, and comfortable buses, it supports smooth and efficient corporate travel planning."
},
{
"name": "Affordable Bus Maval",
"description": "Affordable Bus Maval delivers cost-effective bus rental solutions without compromising on comfort or safety. Suitable for families, schools, social groups, and religious tours, this service combines economical pricing with dependable vehicles and professional drivers."
},
{
"name": "Chauffeur Driven Bus Maval",
"description": "Chauffeur Driven Bus Maval ensures a stress-free travel experience with trained and professional drivers who handle routes, traffic, and schedules efficiently. Passengers can relax and enjoy the journey, making this service ideal for tours, events, corporate travel, and group outings."
},
{
"name": "Best Bus Service Maval",
"description": "Best Bus Service Maval is known for its punctuality, clean buses, and customer-focused approach. Whether for tourist travel, picnics, corporate trips, or group outings, this service guarantees reliable transportation and a comfortable journey every time."
},
{
"name": "Group Travel Bus Maval",
"description": "Group Travel Bus Maval offers organized transportation solutions for large groups such as families, friends, corporate teams, and tour groups. Spacious buses, coordinated planning, and reliable drivers ensure everyone travels together safely and comfortably."
},
{
"name": "Weekend Trip Bus Maval",
"description": "Weekend Trip Bus Maval provides convenient and comfortable bus services for short getaways and weekend tours from Maval. Ideal for families, friends, and corporate groups, this service ensures well-planned travel, relaxed journeys, and enjoyable weekend experiences."
},
{
"name": "Online Bus Booking Maval",
"description": "Online Bus Booking Maval allows quick and easy bus reservations with instant confirmation and multiple vehicle options. Travelers can plan trips efficiently with flexible scheduling, transparent pricing, and a simple booking process that saves time and effort."
},
{
"name": "Event Bus Maval",
"description": "Event Bus Maval offers dedicated transportation services for weddings, parties, exhibitions, conferences, and special events. With reliable scheduling, comfortable buses, and professional drivers, it ensures smooth and organized movement of guests and participants."
},
{
"name": "Maval Travel Bus",
"description": "Maval Travel Bus provides complete travel solutions for local sightseeing and outstation journeys. Combining comfort, safety, affordability, and professional service, it caters to tourists, families, corporate clients, and group travelers looking for dependable bus transportation."
}
],
"tableData": [
["Bus On Rent in Maval", "Bus Hire Maval"],
["AC Bus Maval", "Luxury Bus Maval"],
["Tourist Bus Maval", "Picnic Bus Maval"],
["Corporate Bus Maval", "Affordable Bus Maval"],
["Chauffeur Driven Bus Maval", "Best Bus Service Maval"],
["Group Travel Bus Maval", "Weekend Trip Bus Maval"],
["Online Bus Booking Maval", "Event Bus Maval"],
["Maval Travel Bus", "—"]
]
,



"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Maval with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers dependable and comfortable bus rental services in Maval, perfect for group outings, school trips, corporate tours, and family travels."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air-conditioned, and routinely serviced to ensure a smooth and pleasant journey throughout Maval and nearby destinations."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Maval routes, ensuring a safe, timely, and stress-free travel experience for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for bus rentals in Maval, covering fuel, tolls, and driver allowances with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your Maval bus rental."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from hourly, half-day, full-day, or customized rental packages based on your group’s needs and travel schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for bus rentals in Maval."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Maval?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services in Maval for various travel needs.'
  },
  {
    question: 'How can I book a bus in Maval?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for rent in Maval?',
    answer: 'Sanavi Travels offers a range of buses including mini buses, 20-seater, 32-seater, 45-seater, and 50-seater options to suit your group size.'
  },
  {
    question: 'Are the drivers experienced with routes around Maval?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Maval routes, ensuring safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations in Maval?',
    answer: 'Absolutely. You can select your preferred pickup and drop-off locations anywhere in Maval and nearby areas.'
  },
  {
    question: 'Is the bus service in Maval available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock bus rental services in Maval to suit your travel schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus rental bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip in Maval.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sunil Gaikwad',
    feedback: 'We rented a bus in Maval from Sanavi Travels and had an excellent journey. Comfortable seats and professional driver!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Kavita More',
    feedback: 'Sanavi Travels provided punctual service and a clean bus for our Maval trip. Highly recommended!',
    rating: 5
  }
];











































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Bus On Rent in Maval - Sanavi Travels",
  "description": "Sanavi Travels offers AC, luxury, tourist, picnic, corporate, and affordable bus rentals in Maval. Chauffeur-driven buses for group travel, weekend trips, events, and online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "38"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Bus On Rent in Maval | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Sanavi Travels offers AC, luxury, tourist, picnic, corporate, and affordable bus rentals in Maval. Chauffeur-driven buses for group travel, weekend trips, events, and online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/130.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinmaval;